import {DialogActions, DialogTitle} from '@mui/material';
import React, {FC, SetStateAction, useCallback} from 'react';
import {localized} from '../../../i18n/i18n';
import {BasicButton} from '../default-components/buttons/basic-button';
import {BasicModal} from '../default-components/modal/basic-modal';

interface Props {
  open: boolean;
  setOpen: (value: SetStateAction<boolean>) => void;
  title: string;
  handleDeleteConfirm: () => void;
  removeText?: boolean;
}

export const ConfirmDeleteDialog: FC<Props> = React.memo((props) => {
  const {setOpen, handleDeleteConfirm} = props;
  const handleDialogCancel = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleDeleteConfirmLocal = useCallback(() => {
    handleDeleteConfirm();
    setOpen(false);
  }, [setOpen, handleDeleteConfirm]);

  return (
    <BasicModal open={props.open}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogActions>
        <BasicButton onClick={handleDialogCancel} text={localized('Cancel')} buttonColor={'primary'} />
        <BasicButton
          onClick={handleDeleteConfirmLocal}
          text={props.removeText ? localized('Remove') : localized('Delete')}
          buttonColor={'error'}
        />
      </DialogActions>
    </BasicModal>
  );
});
